module.exports = __webpack_public_path__ + "static/media/classroom1.fd25af2e.png";